(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Bombas", [], factory);
	else if(typeof exports === 'object')
		exports["Bombas"] = factory();
	else
		root["Bombas"] = root["Bombas"] || {}, root["Bombas"]["app"] = factory();
})(self, () => {
return 